import { Container as MapDiv, Marker, NaverMap, useNavermaps } from 'react-naver-maps';
import { useState } from 'react';
import useIsMobile from '../../../hook/useIsMobile';

export default function OfficeBlock({ name, address, lat, lng }) {
  const [map, setMap] = useState(null);
  const navermaps = useNavermaps();


  return (
    <div className='w-full text-[#1E1E1E]'>
      <div className="mb-[20px] text-[24px] font-bold">{name}</div>
      <MapDiv
        style={{
          width: '100%',
          height: '450px',
          borderRadius: '8px'
        }}
      >
        <NaverMap
          ref={setMap}
          defaultCenter={new navermaps.LatLng(lat, lng)}
          defaultZoom={17}
        >
          <Marker position={new navermaps.LatLng(lat, lng)} />
        </NaverMap>
      </MapDiv>

      <dl className='mt-[30px]'>
        <dt className='font-semibold'>주소</dt>
        <dd className='pl-[50px]'>{address}</dd>
      </dl>
    </div>
  )
}